import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={26}
    height={24}
    viewBox="0 0 26 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.79661 20.3496L2.6056 22.7781C1.94728 23.2791 1 22.8096 1 21.9823V4C1 2.34315 2.34315 1 4 1H22C23.6569 1 25 2.34315 25 4V16.9412C25 18.598 23.6569 19.9412 22 19.9412H7.00781C6.57026 19.9412 6.14479 20.0847 5.79661 20.3496Z"
      stroke="#4F4F4F"
      strokeWidth={1.2}
    />
    <path
      d="M7 8H20"
      stroke="#4F4F4F"
      strokeWidth={1.2}
      strokeLinecap="round"
    />
    <path
      d="M7 13H13"
      stroke="#4F4F4F"
      strokeWidth={1.2}
      strokeLinecap="round"
    />
  </svg>
);
export default SVGComponent;
